function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getBaiduLocationAccountListApi, addBaiduLocationAccountApi, editBaiduLocationAccountApi, deleteBaiduLocationAccountApi, testBaiduLocationAccountApi, setCurrentBaiduLocationAccountApi, getCurrentBaiduLocationAccountApi, resetTodayStatsBaiduLocationAccountApi } from '@/api/systemConfig';
export default {
  name: 'BaiduLocationConfig',
  data: function data() {
    return {
      accounts: [],
      currentAccount: null,
      dialogVisible: false,
      dialogTitle: '添加账号',
      editIndex: -1,
      submitLoading: false,
      resetLoading: false,
      viewMode: 'card',
      // 'card' or 'list'
      totalStats: {
        totalSuccess: 0,
        totalFail: 0,
        todaySuccess: 0,
        todayFail: 0
      },
      currentAccountData: {
        accountName: '',
        ak: '',
        sk: '',
        apiUrl: 'https://api.map.baidu.com/reverse_geocoding/v3?',
        status: true,
        sort: 0
      },
      accountRules: {
        accountName: [{
          min: 0,
          max: 50,
          message: '账号名称长度不能超过50个字符',
          trigger: 'blur'
        }],
        ak: [{
          required: true,
          message: '请输入AK',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: 'AK长度在1到50个字符',
          trigger: 'blur'
        }],
        sk: [{
          required: true,
          message: '请输入SK',
          trigger: 'blur'
        }, {
          min: 1,
          max: 200,
          message: 'SK长度在1到200个字符',
          trigger: 'blur'
        }],
        apiUrl: [{
          required: true,
          message: '请输入API URL',
          trigger: 'blur'
        }, {
          type: 'url',
          message: '请输入正确的URL格式',
          trigger: 'blur'
        }],
        status: [{
          required: true,
          message: '请选择状态',
          trigger: 'change'
        }],
        sort: [{
          required: true,
          message: '请输入排序号',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 0,
          max: 999,
          message: '排序号必须在0-999之间',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.loadConfig();
    this.loadCurrentAccount();
  },
  methods: {
    // 加载配置
    loadConfig: function () {
      var _loadConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return getBaiduLocationAccountListApi();
            case 1:
              response = _context.v;
              this.accounts = response || [];
              this.calculateStats();
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('加载百度定位配置失败:', _t);
              this.accounts = [];
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadConfig() {
        return _loadConfig.apply(this, arguments);
      }
      return loadConfig;
    }(),
    // 加载当前使用的账号
    loadCurrentAccount: function () {
      var _loadCurrentAccount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return getCurrentBaiduLocationAccountApi();
            case 1:
              response = _context2.v;
              this.currentAccount = response;
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.error('加载当前账号失败:', _t2);
              this.currentAccount = null;
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function loadCurrentAccount() {
        return _loadCurrentAccount.apply(this, arguments);
      }
      return loadCurrentAccount;
    }(),
    // 计算统计数据
    calculateStats: function calculateStats() {
      this.totalStats = {
        totalSuccess: this.accounts.reduce(function (sum, acc) {
          return sum + (acc.callCount || 0);
        }, 0),
        totalFail: this.accounts.reduce(function (sum, acc) {
          return sum + (acc.failCount || 0);
        }, 0),
        todaySuccess: this.accounts.reduce(function (sum, acc) {
          return sum + (acc.todayCallCount || 0);
        }, 0),
        todayFail: this.accounts.reduce(function (sum, acc) {
          return sum + (acc.todayFailCount || 0);
        }, 0)
      };
    },
    // 获取账号索引
    getAccountIndex: function getAccountIndex(accountId) {
      var index = this.accounts.findIndex(function (acc) {
        return acc.id === accountId;
      });
      return index !== -1 ? index + 1 : '未知';
    },
    // 添加账号
    addAccount: function addAccount() {
      var _this = this;
      this.editIndex = -1;
      this.dialogTitle = '添加百度定位账号';
      this.currentAccountData = {
        accountName: '',
        ak: '',
        sk: '',
        apiUrl: 'https://api.map.baidu.com/reverse_geocoding/v3?',
        status: true,
        sort: 0
      };
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this.$refs.accountForm && _this.$refs.accountForm.clearValidate();
      });
    },
    // 编辑账号
    editAccount: function editAccount(index) {
      var _this2 = this;
      var account = this.accounts[index];
      this.editIndex = index;
      this.dialogTitle = '编辑百度定位账号';
      this.currentAccountData = _objectSpread({}, account);
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this2.$refs.accountForm && _this2.$refs.accountForm.clearValidate();
      });
    },
    // 删除账号
    deleteAccount: function () {
      var _deleteAccount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(index) {
        var account, accountName, _error$response, _error$response$data, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              account = this.accounts[index];
              accountName = account.accountName || '账号 ' + (index + 1);
              _context3.p = 1;
              _context3.n = 2;
              return this.$confirm("\u786E\u5B9A\u5220\u9664\u767E\u5EA6\u5B9A\u4F4D\u8D26\u53F7 \"".concat(accountName, "\" \u5417\uFF1F\n\n\u6B64\u64CD\u4F5C\u4E0D\u53EF\u6062\u590D\uFF0C\u8BF7\u8C28\u614E\u64CD\u4F5C\uFF01"), '删除确认', {
                confirmButtonText: '确定删除',
                cancelButtonText: '取消',
                type: 'warning',
                confirmButtonClass: 'el-button--danger'
              });
            case 2:
              _context3.n = 3;
              return deleteBaiduLocationAccountApi(account.id);
            case 3:
              this.$message.success('账号删除成功');
              _context3.n = 4;
              return this.loadConfig();
            case 4:
              _context3.n = 5;
              return this.loadCurrentAccount();
            case 5:
              _context3.n = 7;
              break;
            case 6:
              _context3.p = 6;
              _t3 = _context3.v;
              if (_t3 !== 'cancel') {
                console.error('删除账号失败:', _t3);
                this.$message.error(((_error$response = _t3.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || '删除失败');
              }
            case 7:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 6]]);
      }));
      function deleteAccount(_x) {
        return _deleteAccount.apply(this, arguments);
      }
      return deleteAccount;
    }(),
    // 确认账号
    confirmAccount: function confirmAccount() {
      var _this3 = this;
      this.$refs.accountForm.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(valid) {
          var _error$response2, _error$response2$data, _t4;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.p = _context4.n) {
              case 0:
                if (!valid) {
                  _context4.n = 10;
                  break;
                }
                _this3.submitLoading = true;
                _context4.p = 1;
                if (!(_this3.editIndex === -1)) {
                  _context4.n = 3;
                  break;
                }
                _context4.n = 2;
                return addBaiduLocationAccountApi(_this3.currentAccountData);
              case 2:
                _this3.$message.success('百度定位账号添加成功');
                _context4.n = 5;
                break;
              case 3:
                _context4.n = 4;
                return editBaiduLocationAccountApi(_this3.currentAccountData);
              case 4:
                _this3.$message.success('百度定位账号编辑成功');
              case 5:
                _this3.dialogVisible = false;
                _context4.n = 6;
                return _this3.loadConfig();
              case 6:
                _context4.n = 7;
                return _this3.loadCurrentAccount();
              case 7:
                _context4.n = 9;
                break;
              case 8:
                _context4.p = 8;
                _t4 = _context4.v;
                console.error('保存账号失败:', _t4);
                _this3.$message.error(((_error$response2 = _t4.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.message) || '保存失败');
              case 9:
                _context4.p = 9;
                _this3.submitLoading = false;
                return _context4.f(9);
              case 10:
                return _context4.a(2);
            }
          }, _callee4, null, [[1, 8, 9, 10]]);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 测试账号
    testAccount: function () {
      var _testAccount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(index) {
        var account, accountName, response, errMsg, _t5, _t6;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              account = this.accounts[index];
              accountName = account.accountName || '账号 ' + (index + 1);
              this.$message.info("\u6B63\u5728\u6D4B\u8BD5\u767E\u5EA6\u5B9A\u4F4D\u8D26\u53F7 \"".concat(accountName, "\"..."));
              _context5.p = 1;
              _context5.n = 2;
              return testBaiduLocationAccountApi(account.id);
            case 2:
              response = _context5.v;
              try {
                this.$message.success(response || '测试成功');
              } catch (msgErr) {
                // 防止 message 调用异常导致页面崩溃
                console.warn('消息提示异常', msgErr);
              }
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t5 = _context5.v;
              console.error('测试账号失败:', _t5);
              try {
                errMsg = _t5 && _t5.response && _t5.response.data && _t5.response.data.message ? _t5.response.data.message : _t5 && _t5.message ? _t5.message : '测试失败';
                this.$message.error(errMsg);
              } catch (msgErr) {
                console.warn('错误提示异常', msgErr);
              }
            case 4:
              _context5.p = 4;
              _context5.p = 5;
              _context5.n = 6;
              return this.loadConfig();
            case 6:
              _context5.n = 8;
              break;
            case 7:
              _context5.p = 7;
              _t6 = _context5.v;
              console.warn('重新加载配置失败', _t6);
            case 8:
              return _context5.f(4);
            case 9:
              return _context5.a(2);
          }
        }, _callee5, this, [[5, 7], [1, 3, 4, 9]]);
      }));
      function testAccount(_x3) {
        return _testAccount.apply(this, arguments);
      }
      return testAccount;
    }(),
    // 设置当前账号
    setCurrentAccount: function () {
      var _setCurrentAccount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(index) {
        var account, accountName, _error$response3, _error$response3$data, _t7;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              account = this.accounts[index];
              accountName = account.accountName || '账号 ' + (index + 1);
              _context6.p = 1;
              _context6.n = 2;
              return this.$confirm("\u786E\u5B9A\u5C06 \"".concat(accountName, "\" \u8BBE\u4E3A\u5F53\u524D\u4F7F\u7528\u7684\u767E\u5EA6\u5B9A\u4F4D\u8D26\u53F7\u5417\uFF1F"), '设置确认', {
                confirmButtonText: '确定设置',
                cancelButtonText: '取消',
                type: 'info'
              });
            case 2:
              _context6.n = 3;
              return setCurrentBaiduLocationAccountApi(account.id);
            case 3:
              this.$message.success('当前账号设置成功');
              _context6.n = 4;
              return this.loadConfig();
            case 4:
              _context6.n = 5;
              return this.loadCurrentAccount();
            case 5:
              _context6.n = 7;
              break;
            case 6:
              _context6.p = 6;
              _t7 = _context6.v;
              if (_t7 !== 'cancel') {
                console.error('设置当前账号失败:', _t7);
                this.$message.error(((_error$response3 = _t7.response) === null || _error$response3 === void 0 ? void 0 : (_error$response3$data = _error$response3.data) === null || _error$response3$data === void 0 ? void 0 : _error$response3$data.message) || '设置失败');
              }
            case 7:
              return _context6.a(2);
          }
        }, _callee6, this, [[1, 6]]);
      }));
      function setCurrentAccount(_x4) {
        return _setCurrentAccount.apply(this, arguments);
      }
      return setCurrentAccount;
    }(),
    // 处理操作菜单
    handleAction: function handleAction(command) {
      var action = command.action,
        account = command.account,
        index = command.index;
      switch (action) {
        case 'test':
          this.testAccount(index);
          break;
        case 'setCurrent':
          this.setCurrentAccount(index);
          break;
        case 'edit':
          this.editAccount(index);
          break;
        case 'delete':
          this.deleteAccount(index);
          break;
      }
    },
    // 重置今日统计数据
    resetTodayStats: function () {
      var _resetTodayStats = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _error$response4, _error$response4$data, _t8;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              _context7.n = 1;
              return this.$confirm('确定要重置所有账号的今日统计数据吗？此操作不可恢复！', '重置确认', {
                confirmButtonText: '确定重置',
                cancelButtonText: '取消',
                type: 'warning',
                confirmButtonClass: 'el-button--danger'
              });
            case 1:
              this.resetLoading = true;
              _context7.n = 2;
              return resetTodayStatsBaiduLocationAccountApi();
            case 2:
              this.$message.success('今日统计数据重置成功');
              _context7.n = 3;
              return this.loadConfig();
            case 3:
              _context7.n = 5;
              break;
            case 4:
              _context7.p = 4;
              _t8 = _context7.v;
              if (_t8 !== 'cancel') {
                console.error('重置今日统计失败:', _t8);
                this.$message.error(((_error$response4 = _t8.response) === null || _error$response4 === void 0 ? void 0 : (_error$response4$data = _error$response4.data) === null || _error$response4$data === void 0 ? void 0 : _error$response4$data.message) || '重置失败');
              }
            case 5:
              _context7.p = 5;
              this.resetLoading = false;
              return _context7.f(5);
            case 6:
              return _context7.a(2);
          }
        }, _callee7, this, [[0, 4, 5, 6]]);
      }));
      function resetTodayStats() {
        return _resetTodayStats.apply(this, arguments);
      }
      return resetTodayStats;
    }(),
    // 切换视图模式
    switchViewMode: function switchViewMode(mode) {
      this.viewMode = mode;
    },
    // 隐藏敏感信息
    maskSecret: function maskSecret(secret) {
      if (!secret) return '';
      if (secret.length <= 8) return '*'.repeat(secret.length);
      return secret.substring(0, 4) + '*'.repeat(secret.length - 8) + secret.substring(secret.length - 4);
    }
  }
};